// Fondo de foto tenue (iglesia) para que las secciones no sean un color plano.
// tint = color base de la sección: "ink" (negro) o "navy" (azul oscuro).
export const SectionBg = ({ image, tint = "ink", position = "center" }) => {
  const grad =
    tint === "navy" ? "from-navy via-navy/40 to-navy" : "from-ink via-ink/40 to-ink";
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <img
        src={image}
        alt=""
        loading="lazy"
        style={{ objectPosition: position }}
        className="absolute inset-0 w-full h-full object-cover opacity-[0.15] select-none"
      />
      <div className={`absolute inset-0 bg-gradient-to-b ${grad}`} />
    </div>
  );
};
